<!-- //
dialog 数据源表单添加
@auth xuyd
@date 2024-05-03
//-->
<template>
  <el-dialog
      class="dialog-container"
      :title="title"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="true"
      top="10vh"
      width="600px">
    <div>
      <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="130px" class="form">
        <el-row class="flow-row">
          <el-form-item prop="dsName" label="名称">
            <el-input v-model="form.dsName" clearable :disabled="editMode"/>
          </el-form-item>
          <el-form-item prop="dbType" label="类型">
            <el-select
                v-model="form.dbType"
                placeholder="请选择"
                clearable
                :disabled="editMode"
                style="width: 100%">
              <el-option
                  v-for="item in this.$store.getters.dictType['DB_TYPE']"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="hostName" label="地址">
            <el-input v-model="form.hostName" clearable/>
          </el-form-item>
          <el-form-item prop="port" label="端口">
            <el-input v-model="form.port" clearable/>
          </el-form-item>
          <el-form-item prop="dbName" label="数据库名">
            <el-input v-model="form.dbName" clearable/>
          </el-form-item>
          <el-form-item prop="properties" label="url参数">
            <el-input v-model="form.properties" clearable/>
          </el-form-item>
          <el-form-item prop="username" label="账号">
            <el-input v-model="form.username" clearable/>
          </el-form-item>
          <el-form-item prop="pwd" label="密码">
            <el-input v-model="form.pwd" clearable>
              <el-button slot="append" @click="handleEncrypt">加密</el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="maxWaitTime" label="连接等待时间">
            <el-input v-model="form.maxWaitTime" clearable>
              <template slot="append">秒</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="maxActive" label="最大连接数">
            <el-input v-model="form.maxActive" clearable/>
          </el-form-item>
          <el-form-item prop="queryTimeout" label="查询超时">
            <el-input v-model="form.queryTimeout" clearable>
              <template slot="append">秒</template>
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="hideModal">取 消</el-button>
      <el-button type="primary" size="small" @click="handleOk" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import DatasourceApi from '@/api/datasvc/datasource.api.js';
const FORM_DEFINE = {
      dsName: null,
      dbType: null,
      hostName: null,
      port: null,
      dbName: null,
      properties: null,
      username: null,
      pwd: null,
      maxWaitTime: 120,
      maxActive: 20,
      queryTimeout: 300,
    };
export default {
  name: 'ViewDatabaseAdd',
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
    {dictType: 'DB_TYPE', dataType: String},
  ],
  data() {
    return {
      loading: false,
      visible: false,
      title: '新建数据源',
      opts: {
        mode: null,
      },
      form: this.$util.mergeObject(FORM_DEFINE),
      rules: {
        dsName: [{required: true, message: "请输入数据源名称", trigger: 'blur'}],
        hostName: [{required: true, message: "请输入地址", trigger: 'blur'}],
        port: [{required: true, message: "请输入端口", trigger: 'blur'}],
        dbName: [{required: true, message: "请输入数据库名", trigger: 'blur'}],
        username: [{required: true, message: "请输入账号", trigger: 'blur'}],
        pwd: [{required: true, message: "请输入密码", trigger: 'blur'}],
      },
    }
  },
  computed: {
    editMode() {
      return this.opts.mode === 2;
    }
  },
  methods: {
    showModal({data, mode, title, onOk}) {
      let that = this;
      this.dialogShow({
        data: data,
        mode: mode,
        title: title,
        onOk(data) {
          let promise = onOk && onOk(data);
          if (promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        },
      })
    },
    dialogShow(opts) {
      console.log("===========>", opts)
      this.visible = true;
      this.opts.mode = opts.mode
      this.opts.onOk = opts.onOk
      this.opts.onCancel = opts.onCancel
      if (!opts.data) {
        opts.data = {};
      }
      opts.data = this.$util.mergeObject(FORM_DEFINE,  opts.data)
      this.form = opts.data
      this.title = opts.title
    },

    hideModal() {
      this.visible = false;
      this.$refs["refForm"].clearValidate();
      this.$refs["refForm"].resetFields();
    },

    /**
     * 加密
     */
    handleEncrypt() {
      DatasourceApi.encrypt(encodeURIComponent(this.form.pwd)).then(resp => {
        this.form.pwd = resp.data;
      })
    },

    /**
     * 点击确定
     */
    handleOk() {
      let data = {...this.form};
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.loading = true;
          return DatasourceApi.saveInfo(data).then(resp => {
            this.loading = false;
            this.$modal.msgSuccess("保存成功")
            this.opts.onOk(resp.data);
            this.hideModal();
          }).catch(() => {
            this.loading = false;
          });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  padding-right: 50px;
}
</style>
